import api from "./api";
import { Mitglied } from "../types/Mitglied";

interface FetchMitgliederResponse {
  content: Mitglied[];
  totalPages: number;
}

export const fetchMitgliederApi = async (
  search: string,
  page: number,
  size: number,
) => {
  const res = await api.get<FetchMitgliederResponse>(`/admin/mitglieder`, {
    params: { search, page, size },
    withCredentials: true,
  });
  return res.data;
};

export const deleteMitgliedApi = async (id: number) => {
  await api.delete(`/admin/mitglieder/${id}`, { withCredentials: true });
};

export const resetPasswordApi = async (id: number, newPassword: string) => {
  await api.post(`/admin/mitglieder/${id}/reset-password`, newPassword, {
    withCredentials: true,
    headers: {
      // Wichtig: Dem Backend sagen, dass es sich um einen einfachen String handelt
      "Content-Type": "text/plain",
    },
  });
};

export const changeRoleApi = async (id: number, role: string) => {
  await api.post(`/admin/mitglieder/${id}/role`, role.trim().toUpperCase(), {
    withCredentials: true,
    headers: { "Content-Type": "text/plain" },
  });
};
